export default "__VITE_ASSET__DCormdrM__"